import { render, staticRenderFns } from "./WithdrawForm.vue?vue&type=template&id=6c396f76&"
import script from "./WithdrawForm.vue?vue&type=script&lang=js&"
export * from "./WithdrawForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports